<mat-toolbar color="primary" class="action-toolbar">
    <button mat-icon-button (click)="returnToParent()" matTooltip="Back"><mat-icon
            color="primary">arrow_back_ios</mat-icon></button>
    <h3>{{ patient | patientHeading:'Edit':'Add Patient' }}</h3>
    <div>
        <button mat-icon-button (click)="openAddUsingImageDialog()"
            matTooltip="Scan a picture to obtain patient details for adding"><mat-icon
                class="ai-feature">document_scanner</mat-icon></button>

        <button mat-icon-button *ngIf="patient && patient.id" (click)="deletePatient()"
            matTooltip="Delete Patient"><mat-icon color="warn">delete</mat-icon></button>

        <button mat-icon-button (click)="savePatient()"
            [matTooltip]="status ==='invite'? 'Send Invite' : 'Save Patient' " [disabled]="isLoading"><mat-icon
                color="primary">{{status ==='invite'? 'send' : 'save'}}</mat-icon></button>
        <!-- <button mat-icon-button [disabled]="form.invalid" (click)="savePatient()" matTooltip="Save Patient"><mat-icon
                [color]="form.invalid ? '' : 'primary'">save</mat-icon></button> -->
    </div>
</mat-toolbar>
<div id="top"></div>

<div class="patient-details-container">
    <div class="requires-validation-banner" *ngIf="isQuickAdd">
        <mat-icon class="bolt-icon">bolt</mat-icon>
        <div class="messages">
            <p><strong>Express Add:</strong> Create a patient file with minimal details for immediate
                recording.
                The file will be marked as incomplete and can be completed later. </p>

            <p>
                For faster setup press
                <button mat-icon-button (click)="openAddUsingImageDialog()"
                    matTooltip="Scan admission sheet to auto-fill patient details"><mat-icon
                        class="ai-feature">document_scanner</mat-icon></button>
                to scan a hospital admission sheet and automatically extract patient information. The
                scanned
                image will be saved for future reference.
            </p>
        </div>
    </div>

    <div class="requires-validation-banner" *ngIf="patient && patient.requiresValidation">
        <mat-icon class="bolt-icon">bolt</mat-icon>
        <div class="messages">
            <p><strong>Incomplete Patient Record:</strong> This patient file contains missing or
                incomplete information that needs to be reviewed and completed. Please fill in all
                required fields below and save to mark this record as complete.</p>
        </div>
    </div>

    <div class="requires-validation-banner" *ngIf="patient && patient.wasSelfBoarded">
        <mat-icon class="bolt-icon">medical_information</mat-icon>
        <div class="messages">
            <p><strong>Patient Information Requires Review:</strong> Following patient self-boarding the information in
                this file has not been validated. Please review, complete any missing information and press
                save to validate this file as complete. </p>
        </div>
    </div>

    <div class="requires-validation-banner" *ngIf="patient && patient.requiresICDValidation">
        <mat-icon class="bolt-icon">warning_amber</mat-icon>
        <div class="messages">
            <p><strong>Diagnosis and ICD-10 Codes Require Review:</strong> This record was automatically coded for
                ICD-10 with "Z00" and diagnosis was set to "UNSPECIFIED". Please review the diagnosis and update the
                ICD-10 codes.</p>
        </div>
    </div>

    <div class="requires-validation-banner" *ngIf="patient && patient.status === 'invite'">
        <mat-icon class="bolt-icon">mail</mat-icon>
        <div class="messages">
            <p><strong>Pending Invite:</strong> This file is still in a pending invite state. Please ensure the patient
                completes the invite process to ensure accurate and complete patient information.</p>
        </div>
    </div>
    <mat-accordion multi="true">
        <!-- Clinical/Admission Section - Always show for inpatient/OPD, hide for invite -->
        <ng-container *ngIf="status !== 'invite'">
            <mat-expansion-panel [expanded]="sectionExpandedStates.clinical">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{status === 'inpatient' ? 'ADMISSION INFORMATION' : 'CLINICAL INFORMATION'}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">


                    <mat-form-field appearance="outline">
                        <mat-label>Patient Type</mat-label>
                        <mat-select formControlName="status">
                            <mat-option value="inpatient">Inpatient</mat-option>
                            <mat-option value="opd">Outpatient</mat-option>
                            <mat-option value="invite" *ngIf="!stateMode">Invite</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!patient?.id">
                        <mat-label>{{status === 'invite' ? 'Requesting Physician' : 'Treating Physician'}}</mat-label>
                        <mat-select formControlName="physicianId">
                            <mat-option *ngFor="let user of groupUsers" [value]="user.userId">{{user.title}}
                                {{user.name}}
                                {{user.surname}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="status === 'inpatient'">
                        <mat-label>Admission Date</mat-label>
                        <input matInput [matDatepicker]="admissionDatePicker" formControlName="admissionDate"
                            placeholder="DD/MM/YYYY" [max]="todayDate">
                        <mat-datepicker-toggle matSuffix [for]="admissionDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #admissionDatePicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="status === 'inpatient'">
                        <mat-label>Hospital</mat-label>
                        <mat-select formControlName="hospitalId" (selectionChange)="selectHospital($event)">
                            <mat-option *ngFor="let hospital of hospitals"
                                [value]="hospital.id">{{hospital.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline"
                        *ngIf="status === 'inpatient' && form.get('hospitalId')?.value">
                        <mat-label>Ward</mat-label>
                        <mat-select formControlName="wardId">
                            <mat-option *ngFor="let ward of wards" [value]="ward.id">{{ward.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="status === 'inpatient' && !isQuickAdd">
                        <mat-label>Bed</mat-label>
                        <input matInput formControlName="bed">
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="status === 'inpatient'">
                        <mat-label>Admission Type</mat-label>
                        <mat-select formControlName="admissionType">
                            <mat-option value="Day Case Admission">Day Case Admission</mat-option>
                            <mat-option value="Elective Admission">Elective Admission</mat-option>
                            <mat-option value="Emergency Admission">Emergency Admission</mat-option>
                            <mat-option value="Expedited Admission">Expedited Admission</mat-option>
                            <mat-option value="Urgent Admission">Urgent Admission</mat-option>
                            <mat-option value="EMU Admission">EMU Admission</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="field-with-action" *ngIf="!isQuickAdd">
                        <mat-form-field appearance="outline">
                            <mat-label>Diagnosis/Active Problem</mat-label>
                            <textarea matInput cdkTextareaAutosize="true" formControlName="diagnosis"></textarea>
                        </mat-form-field>
                        <button mat-icon-button matTooltip="Add additional diagnosis" (click)="addDiagnosisField()"
                            *ngIf="visibleDiagnosisFields.length <= 24"
                            color="primary"><mat-icon>add</mat-icon></button>
                    </div>

                    <ng-container *ngIf="!isQuickAdd">
                        <ng-container *ngFor="let field of visibleDiagnosisFields; let i = index">
                            <mat-form-field appearance="outline">
                                <mat-label>Diagnosis/Active Problem {{ i + 2 }}</mat-label>
                                <textarea matInput cdkTextareaAutosize="true" [formControlName]="field"></textarea>
                            </mat-form-field>
                        </ng-container>
                    </ng-container>

                    <app-icd-code-selector [patientSex]="icdCodingSex" [patientAge]="icdCodingAge" [defaultOnsetDate]="icdDefaultOnsetDate" [initialCodes]="selectedIcdCodes" (codesChanged)="onIcdCodesChanged($event)"
                        [isRequired]="true" *ngIf="!isQuickAdd"></app-icd-code-selector>

                    <div *ngIf="patient?.id">
                        <mat-form-field appearance="outline">
                            <mat-label>Most Recent Reason For Visit</mat-label>
                            <textarea matInput cdkTextareaAutosize="true" formControlName="reasonForVisiting"
                                placeholder="Often set by the patient during invite; you can edit or clear it here."></textarea>
                            <button mat-icon-button matSuffix matTooltip="Clear reason for visit" type="button"
                                class="m-t-5" (click)="form.get('reasonForVisiting')?.setValue('')"
                                *ngIf="form.get('reasonForVisiting')?.value">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Invite Section - Only show for invite patients -->
        <ng-container *ngIf="status === 'invite' && !stateMode">
            <mat-expansion-panel [expanded]="sectionExpandedStates.clinical">
                <mat-expansion-panel-header>
                    <mat-panel-title>INVITE INFORMATION</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <div class="requires-validation-banner" *ngIf="isQuickAdd">
                        <mat-icon class="bolt-icon">bolt</mat-icon>
                        <div class="messages">
                            <p><strong>Express Add:</strong> Create a patient file with minimal details for immediate
                                recording.
                                The file will be marked as incomplete and can be completed later. </p>

                            <p>
                                For faster setup press
                                <button mat-icon-button (click)="openAddUsingImageDialog()"
                                    matTooltip="Scan admission sheet to auto-fill patient details"><mat-icon
                                        class="ai-feature">document_scanner</mat-icon></button>
                                to scan a hospital admission sheet and automatically extract patient information. The
                                scanned
                                image will be saved for future reference.
                            </p>
                        </div>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Patient Type</mat-label>
                        <mat-select formControlName="status">
                            <mat-option value="inpatient">Inpatient</mat-option>
                            <mat-option value="opd">Outpatient</mat-option>
                            <mat-option value="invite" *ngIf="!stateMode">Invite</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!patient?.id">
                        <mat-label>Requesting Physician</mat-label>
                        <mat-select formControlName="physicianId">
                            <mat-option *ngFor="let user of groupUsers" [value]="user.userId">{{user.title}}
                                {{user.name}}
                                {{user.surname}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Surname</mat-label>
                        <input matInput formControlName="surname">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="email" type="email">
                        <mat-error *ngIf="form.get('email')?.value && form.get('email')?.invalid">Please enter a valid
                            email</mat-error>
                    </mat-form-field>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('mobileNumber')?.value" placeholder="Tel (Mobile)"
                        (valueChange)="form.patchValue({mobileNumber:$event})" name="mobileNumber"
                        classList="full-width"
                        [required]="form.get('mobileNumber')?.hasError('required') ?? false"></app-intl-phone-input>

                    <div class="token-balance-warning"
                        *ngIf="!isPremium && textMessageBalance && textMessageBalance <= 5">
                        <mat-icon>warning</mat-icon>
                        <p class="p-l-10">You have <strong>{{ textMessageBalance }}</strong> text message credits left.
                            Please recharge soon to ensure you are able to continue sending text message invites.</p>
                    </div>
                    <div class="token-balance-warning" *ngIf="!isPremium && textMessageBalance == 0">
                        <mat-icon>error</mat-icon>
                        <p class="p-l-10"> You currently have <strong>{{ textMessageBalance }}</strong> text message
                            credits remaining. To continue sending text message invites, please recharge your credits.
                            Email invites will remain fully operational. </p>
                    </div>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Personal Information Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite'">
            <mat-expansion-panel [expanded]="sectionExpandedStates.personal">
                <mat-expansion-panel-header>
                    <mat-panel-title>PERSONAL INFORMATION</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <mat-form-field appearance="outline" *ngIf="!isQuickAdd">
                        <mat-label>Title</mat-label>
                        <mat-select formControlName="title">
                            <mat-option *ngFor="let title of titles" [value]="title.value">{{title.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name">
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!isQuickAdd">
                        <mat-label>Initials</mat-label>
                        <input matInput formControlName="initials">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Surname</mat-label>
                        <input matInput formControlName="surname">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Patient File Number</mat-label>
                        <input matInput formControlName="patientNumber">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="dobPicker" formControlName="dob" placeholder="DD/MM/YYYY"
                            [max]="todayDate">
                        <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                        <mat-datepicker #dobPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!isQuickAdd">
                        <mat-label>Gender</mat-label>
                        <mat-select formControlName="gender">
                            <mat-option value="Male">Male</mat-option>
                            <mat-option value="Female">Female</mat-option>
                            <mat-option value="Other">Other</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!isQuickAdd">
                        <mat-label>Country</mat-label>
                        <mat-select formControlName="country">
                            <mat-option *ngFor="let country of countries"
                                [value]="country.value">{{country.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!isQuickAdd">
                        <mat-label>Identification Type</mat-label>
                        <mat-select formControlName="idType" (selectionChange)="onIDTypeChange($event)">
                            <mat-option value="id">SA ID</mat-option>
                            <mat-option value="passport">Passport</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="form.get('idType')?.value === 'id' && !isQuickAdd">
                        <mat-label>ID Number</mat-label>
                        <input matInput formControlName="idNumber">
                        <mat-error *ngIf="form.get('idNumber')?.hasError('invalidSaId')">
                            {{ form.get('idNumber')?.errors?.['invalidSaId'] }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline"
                        *ngIf="form.get('idType')?.value === 'passport' && !isQuickAdd">
                        <mat-label>Passport Number</mat-label>
                        <input matInput formControlName="passportNumber">
                    </mat-form-field>

                    <mat-form-field appearance="outline"
                        *ngIf="form.get('idType')?.value === 'passport' && !isQuickAdd">
                        <mat-label>Passport Country</mat-label>
                        <mat-select formControlName="passportCountry">
                            <mat-option *ngFor="let country of countries"
                                [value]="country.value">{{country.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>



                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Contact Information Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite'">
            <mat-expansion-panel [expanded]="sectionExpandedStates.contact">
                <mat-expansion-panel-header>
                    <mat-panel-title>CONTACT INFORMATION</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <div class="form-field-checkbox">
                        <mat-checkbox labelPosition="before" (change)="toggleNoDetailsAvailable($event)"
                            color="primary">No
                            details available</mat-checkbox>
                    </div>

                    <div class="requires-validation-banner" *ngIf="noContactDetails">
                        <mat-icon>warning</mat-icon>
                        <div class="messages">
                            <p>NOTE: We strongly advise that you provide contact details for the patient. This will
                                enable
                                patient consenting and communication workflows.
                            </p>
                        </div>
                    </div>

                    <ng-container *ngIf="!noContactDetails">
                        <p class="hint warn p-b-2" *ngIf="emailSuggestion">{{emailSuggestion}}</p>
                        <mat-form-field appearance="outline">
                            <mat-label>Email Address</mat-label>
                            <input matInput formControlName="email" type="email">
                            <mat-error *ngIf="form.get('email')?.value && form.get('email')?.invalid">Please enter a
                                valid
                                email</mat-error>
                        </mat-form-field>

                        <app-intl-phone-input [preferredCountries]="['za']"
                            [providedValue]="form.get('mobileNumber')?.value" placeholder="Tel (Mobile)"
                            (valueChange)="form.patchValue({mobileNumber:$event})" name="mobileNumber"
                            classList="full-width"
                            [required]="form.get('mobileNumber')?.hasError('required') ?? false"></app-intl-phone-input>

                        <!-- Additional contact fields - only show when not quick add -->
                        <ng-container *ngIf="!isQuickAdd">
                            <app-intl-phone-input [preferredCountries]="['za']"
                                [providedValue]="form.get('phoneNumber')?.value" placeholder="Tel (Home)"
                                (valueChange)="form.patchValue({phoneNumber:$event})" name="phoneNumber"
                                classList="full-width"></app-intl-phone-input>

                            <mat-form-field appearance="outline">
                                <mat-label>Address</mat-label>
                                <textarea matInput cdkTextareaAutosize="true" formControlName="address"></textarea>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Post Code</mat-label>
                                <input matInput formControlName="addressCode" type="number">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Religion</mat-label>
                                <input matInput formControlName="religion">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Home Language</mat-label>
                                <input matInput formControlName="language">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Occupation</mat-label>
                                <input matInput formControlName="occupation">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Employer</mat-label>
                                <input matInput formControlName="employer">
                            </mat-form-field>

                            <app-intl-phone-input [preferredCountries]="['za']"
                                [providedValue]="form.get('workPhone')?.value" placeholder="Tel (Work)"
                                (valueChange)="form.patchValue({workPhone:$event})" name="workPhone"
                                classList="full-width"></app-intl-phone-input>

                            <mat-form-field appearance="outline">
                                <mat-label>Work Address</mat-label>
                                <textarea matInput cdkTextareaAutosize="true" formControlName="workAddress"></textarea>
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Post Code</mat-label>
                                <input matInput formControlName="workAddressCode" type="number">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Marital Status</mat-label>
                                <input matInput formControlName="maritalStatus">
                            </mat-form-field>
                        </ng-container>
                    </ng-container>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Medical Insurance Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite' && !isQuickAdd">
            <mat-expansion-panel [expanded]="sectionExpandedStates.medicalInsurance">
                <mat-expansion-panel-header>
                    <mat-panel-title>MEDICAL INSURANCE</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <app-medical-aid-picker class="medical-aid-picker" [schemes]="schemeReference.schemes"
                        [initial]="medicalAidInitial" label="Medical aid/insurance"
                        (pickChange)="onMedicalAidPick($event)">
                    </app-medical-aid-picker>

                    <mat-form-field appearance="outline">
                        <mat-label>Medical Aid/Insurance Number</mat-label>
                        <input matInput formControlName="medicalAidNumber">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Date Joined</mat-label>
                        <input matInput [matDatepicker]="medicalDateJoinedPicker" formControlName="medicalDateJoined"
                            placeholder="DD/MM/YYYY" [max]="todayDate">
                        <mat-datepicker-toggle matSuffix [for]="medicalDateJoinedPicker"></mat-datepicker-toggle>
                        <mat-datepicker #medicalDateJoinedPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Main Member</mat-label>
                        <input matInput formControlName="medicalMainMember">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Dependant Code</mat-label>
                        <input matInput formControlName="medicalDependantCode">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Gap Cover Name</mat-label>
                        <input matInput formControlName="gapCover">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Gap Cover Policy Number</mat-label>
                        <input matInput formControlName="gapCoverNumber">
                    </mat-form-field>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Person Responsible for Account Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite' && !isQuickAdd">
            <mat-expansion-panel [expanded]="sectionExpandedStates.personResponsible">
                <mat-expansion-panel-header>
                    <mat-panel-title>PERSON RESPONSIBLE FOR ACCOUNT</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <div class="form-field-checkbox">
                        <mat-checkbox labelPosition="before" (change)="copyPatientDetails($event)" color="primary">Copy
                            from
                            patient details</mat-checkbox>
                    </div>

                    <mat-form-field appearance="outline">
                        <mat-label>Title</mat-label>
                        <mat-select formControlName="liableTitle">
                            <mat-option *ngFor="let title of titles" [value]="title.value">{{title.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="liableName">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Initials</mat-label>
                        <input matInput formControlName="liableInitials">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Surname</mat-label>
                        <input matInput formControlName="liableSurname">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Identification Type</mat-label>
                        <mat-select formControlName="liableIdType" (selectionChange)="onIDTypeChange($event, true)">
                            <mat-option value="id">SA ID</mat-option>
                            <mat-option value="passport">Passport</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="form.get('liableIdType')?.value === 'id'">
                        <mat-label>ID Number</mat-label>
                        <input matInput formControlName="liableIdNumber">
                        <mat-error *ngIf="form.get('liableIdNumber')?.hasError('invalidSaId')">
                            {{ form.get('liableIdNumber')?.errors?.['invalidSaId'] }}
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="form.get('liableIdType')?.value === 'passport'">
                        <mat-label>Passport Number</mat-label>
                        <input matInput formControlName="liablePassportNumber">
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="form.get('liableIdType')?.value === 'passport'">
                        <mat-label>Passport Country</mat-label>
                        <mat-select formControlName="liablePassportCountry">
                            <mat-option *ngFor="let country of countries"
                                [value]="country.value">{{country.text}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="liableEmail" type="email">
                        <mat-error *ngIf="form.get('liableEmail')?.invalid">Please enter a valid email</mat-error>
                    </mat-form-field>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('liableMobileNumber')?.value" placeholder="Tel (Mobile)"
                        (valueChange)="form.patchValue({liableMobileNumber:$event})" name="liableMobileNumber"
                        classList="full-width"></app-intl-phone-input>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('liablePhoneNumber')?.value" placeholder="Tel (Home)"
                        (valueChange)="form.patchValue({liablePhoneNumber:$event})" name="liablePhoneNumber"
                        classList="full-width"></app-intl-phone-input>

                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <textarea matInput cdkTextareaAutosize="true" formControlName="liableAddress"></textarea>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Post Code</mat-label>
                        <input matInput formControlName="liableAddressCode" type="number">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Occupation</mat-label>
                        <input matInput formControlName="liableOccupation">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Employer</mat-label>
                        <input matInput formControlName="liableEmployer">
                    </mat-form-field>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('liableWorkPhone')?.value" placeholder="Tel (Work)"
                        (valueChange)="form.patchValue({liableWorkPhone:$event})" name="liableWorkPhone"
                        classList="full-width"></app-intl-phone-input>

                    <mat-form-field appearance="outline">
                        <mat-label>Work Address</mat-label>
                        <textarea matInput cdkTextareaAutosize="true" formControlName="liableWorkAddress"></textarea>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Post Code</mat-label>
                        <input matInput formControlName="liableWorkAddressCode" type="number">
                    </mat-form-field>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Authorizations Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite' && !isQuickAdd">
            <mat-expansion-panel [expanded]="sectionExpandedStates.authorizations">
                <mat-expansion-panel-header>
                    <mat-panel-title>AUTHORIZATIONS</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <!-- B3 — the real records. Only once the patient has an id: PatientAuthorizations
                         is keyed on it, so there is nothing to hang a row on before the first save. -->
                    <!-- Numbers still stored on the patient record (Patient.authorizationNumbers)
                         show in this list too; removing one takes it out of the form, which saves
                         it with the patient. -->
                    <app-authorization-list *ngIf="patient?.id" [patientId]="patient.id" [groupId]="groupId"
                        [dateOfService]="null"
                        (legacyRemoved)="onLegacyAuthorizationRemoved($event)"></app-authorization-list>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Next of Kin Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite' && !isQuickAdd">
            <mat-expansion-panel [expanded]="sectionExpandedStates.nextOfKin">
                <mat-expansion-panel-header>
                    <mat-panel-title>NEXT OF KIN</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <mat-form-field appearance="outline">
                        <mat-label>Next of Kin Name</mat-label>
                        <input matInput formControlName="emergencyContact">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Relationship</mat-label>
                        <input matInput formControlName="emergencyContactRelationship">
                    </mat-form-field>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('emergencyContactMobile')?.value" placeholder="Tel (Mobile)"
                        (valueChange)="form.patchValue({emergencyContactMobile:$event})" name="emergencyContactMobile"
                        classList="full-width"></app-intl-phone-input>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('emergencyContactPhone')?.value" placeholder="Tel (Home)"
                        (valueChange)="form.patchValue({emergencyContactPhone:$event})" name="emergencyContactPhone"
                        classList="full-width"></app-intl-phone-input>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('emergencyContactWork')?.value" placeholder="Tel (Work)"
                        (valueChange)="form.patchValue({emergencyContactWork:$event})" name="emergencyContactWork"
                        classList="full-width"></app-intl-phone-input>

                    <mat-form-field appearance="outline">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="emergencyContactEmail" type="email">
                        <mat-error *ngIf="form.get('emergencyContactEmail')?.invalid">Please enter a valid
                            email</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <textarea matInput cdkTextareaAutosize="true"
                            formControlName="emergencyContactAddress"></textarea>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Post Code</mat-label>
                        <input matInput formControlName="emergencyContactAddressCode" type="number">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Next of Kin 2 Name</mat-label>
                        <input matInput formControlName="emergencyContact2">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Relationship</mat-label>
                        <input matInput formControlName="emergencyContactRelationship2">
                    </mat-form-field>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('emergencyContactMobile2')?.value" placeholder="Tel (Mobile)"
                        (valueChange)="form.patchValue({emergencyContactMobile2:$event})" name="emergencyContactMobile2"
                        classList="full-width"></app-intl-phone-input>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('emergencyContactPhone2')?.value" placeholder="Tel (Home)"
                        (valueChange)="form.patchValue({emergencyContactPhone2:$event})" name="emergencyContactPhone2"
                        classList="full-width"></app-intl-phone-input>

                    <app-intl-phone-input [preferredCountries]="['za']"
                        [providedValue]="form.get('emergencyContactWork2')?.value" placeholder="Tel (Work)"
                        (valueChange)="form.patchValue({emergencyContactWork2:$event})" name="emergencyContactWork2"
                        classList="full-width"></app-intl-phone-input>

                    <mat-form-field appearance="outline">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="emergencyContactEmail2" type="email">
                        <mat-error *ngIf="form.get('emergencyContactEmail2')?.invalid">Please enter a valid
                            email</mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <textarea matInput cdkTextareaAutosize="true"
                            formControlName="emergencyContactAddress2"></textarea>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Post Code</mat-label>
                        <input matInput formControlName="emergencyContactAddressCode2" type="number">
                    </mat-form-field>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Medical Information Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite' && !isQuickAdd">
            <mat-expansion-panel [expanded]="sectionExpandedStates.medicalInfo">
                <mat-expansion-panel-header>
                    <mat-panel-title>MEDICAL INFORMATION</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">

                    <mat-form-field appearance="outline" *ngIf="!isQuickAdd">
                        <mat-label>Height</mat-label>
                        <input matInput formControlName="height" type="number" heightInput>
                        <span matSuffix class="m-r-5"> cm </span>
                    </mat-form-field>

                    <mat-form-field appearance="outline" *ngIf="!isQuickAdd">
                        <mat-label>Weight</mat-label>
                        <input matInput formControlName="weight" type="number" weightInput>
                        <span matSuffix class="m-r-5"> kg </span>
                    </mat-form-field>

                    <app-allergy-list-creator [allergies]="selectedAllergies"
                        [noAllergies]="this.form.get('noAllergies')?.value"
                        (allergiesChanged)="onAllergiesChanged($event)"
                        (noAllergiesChanged)="onNoAllergiesChanged($event)">
                    </app-allergy-list-creator>

                    <app-medical-history-list-creator [history]="selectedMedicalHistory"
                        [noHistory]="this.form.get('noMedicalHistory')?.value"
                        (historyChanged)="onMedicalHistoryChanged($event)"
                        (noHistoryChanged)="onNoMedicalHistoryChanged($event)">
                    </app-medical-history-list-creator>

                    <app-medication-list-creator [medications]="selectedMedicationHistory"
                        [noMedication]="this.form.get('noMedicationHistory')?.value"
                        (medicationChanged)="onMedicationHistoryChanged($event)"
                        (noMedicationChanged)="onNoMedicationHistoryChanged($event)">
                    </app-medication-list-creator>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!-- Medical Team Details Section - Only show for inpatient/OPD -->
        <ng-container *ngIf="status !== 'invite' && !isQuickAdd">
            <mat-expansion-panel [expanded]="sectionExpandedStates.medicalTeam">
                <mat-expansion-panel-header>
                    <mat-panel-title>MEDICAL TEAM DETAILS</mat-panel-title>
                </mat-expansion-panel-header>
                <form [formGroup]="form">
                    <app-medical-team-list-creator [medicalTeam]="selectedMedicalTeam" [colleagueSearch]="true"
                        (teamChanged)="onMedicalTeamChanged($event)"></app-medical-team-list-creator>
                </form>
            </mat-expansion-panel>
        </ng-container>

        <!--
          §30 — THE DOCUMENTS THIS INVITE WILL CARRY.

          INVITE ONLY. Documents ride the invite rail (§19), so there is nothing for them to travel
          with on an inpatient or OPD file — those are created at the desk and never email the
          patient a link. `patient` is absent here because this panel is for CREATING an invite;
          re-opening an existing file must not re-offer a send that already happened.

          The picker hides itself when the practice has no documents, so a practice that has never
          uploaded one sees no new panel at all.
        -->
        <ng-container *ngIf="status === 'invite' && !patient && !stateMode">
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>DOCUMENTS TO SEND</mat-panel-title>
                </mat-expansion-panel-header>
                <app-document-attachment-picker context="invite" [groupId]="groupId"
                    [selection]="selectedDocumentIds" label="Documents to send with this invite"
                    (selectionChange)="selectedDocumentIds = $event"
                    data-test="patient-invite-document-picker">
                </app-document-attachment-picker>
            </mat-expansion-panel>
        </ng-container>
    </mat-accordion>

    <div class="mobile-spacer"></div>
</div>

<!-- In the chat window's frame (src/_cura-window.scss, panel class ai-recording-panel), as the AI
     recording dialog is. -->
<ng-template #scanPatientDetailsDialog>
    <div class="cw-header cw-header--wrap">
        <mat-icon class="kind">document_scanner</mat-icon>
        <div class="title">
            <span class="name">Upload admission sheet</span>
            <span class="subtitle">Photograph or upload the hospital admission sheet and the details are filled in</span>
        </div>
    </div>
    <div mat-dialog-content class="cw-body">

        <div class="p-t-10">

            <div class="ai-locked" *ngIf="lockProcessing && !isPremium">
                <mat-icon>error</mat-icon>
                <p class="p-l-10">You do not have enough AI tokens to continue utilizing AI features. Please recharge
                    your token balance by navigating to settings and selecting the "Subscriptions & Usage" tab.</p>
            </div>

            <ng-container *ngIf="!lockProcessing">

                <div class="token-balance-warning" *ngIf="!isPremium && tokenBalance && tokenBalance <= 100">
                    <mat-icon>warning</mat-icon>
                    <p class="p-l-10">Your token balance is currently R{{ tokenBalance }}. Please
                        recharge soon to ensure you are able to continue utilizing AI features.</p>
                </div>

                <app-file-upload [fileObjects]="[]" [allowMultiple]="false" [allowedFileTypes]="'image/*'"
                    title="Admission Sheet Image" (fileUpload)="onAdmissionSheetUpload($event)"
                    (fileDelete)="onAdmissionSheetDelete($event)" *ngIf="!admissionProcessing" [cameraEnabled]="true"
                    [previewEnabled]="true">
                </app-file-upload>


                <ng-container *ngIf="admissionProcessing">
                    <div class="cw-processing">
                        <mat-spinner diameter="24"></mat-spinner>
                        <span>Processing...</span>
                    </div>
                    <div class="cw-status"
                        [ngClass]="!admissionProcessing ? 'completed' : 'pending'">
                        <span>Extracting patient information</span>
                    </div>

                    <p class="cw-hint"><strong>Note: </strong>MedicAI can make mistakes. We advise that you check the
                        content
                        of the output carefully before accepting it into the patient file.</p>
                </ng-container>

            </ng-container>

        </div>

        <p class="cw-hint">
            By proceeding, you agree to the <a href="assets/documents/IQject Terms of service - v0.5.pdf"
                target="_blank">terms of service</a>
            and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                policy</a>.
        </p>

    </div>

    <div mat-dialog-actions class="cw-actions dialog-actions">
        <span class="spacer"></span>
        <button mat-stroked-button class="quiet-button" [mat-dialog-close]>Close</button>
    </div>

</ng-template>